import React from 'react';
import './CustomCheckbox.scss';

interface IProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  labelText: string;
  highlightedText?: string;
  handleOnClick: any;
  isChecked: boolean;
  bulletColor?: string;
  customStyle?: any;
  disabled?: boolean;
  dataDisabled?: boolean;
  showProductTypeIcon?: boolean;
  productTypeIconText?: string;
  isSubFilter?: boolean;
  customCheckboxAligment?: boolean;
}
type Props = IProps;
export const CustomCheckbox = ({
  labelText,
  highlightedText,
  handleOnClick,
  isChecked,
  bulletColor,
  customStyle,
  disabled,
  dataDisabled,
  showProductTypeIcon,
  productTypeIconText,
  isSubFilter,
  customCheckboxAligment,
  ...rest
}: Props) => {
  return (
    <label
      {...rest}
      className={`custom-checkbox-container${disabled ? ' custom-checkbox-container--disabled-data' : ''}${
        dataDisabled ? ' custom-checkbox-container--no-data' : ''
      }`}
      tabIndex={30}
      style={customStyle}
    >
      {bulletColor && (
        <span
          className="bullet"
          style={{ backgroundColor: bulletColor, display: 'inline-flex', marginRight: 10 }}
        ></span>
      )}
      {showProductTypeIcon && <span className={`product-type-icon-${productTypeIconText}`}>{productTypeIconText}</span>}
      {isSubFilter ? (
        <div className={customCheckboxAligment ? 'sub-filter-label-vertical' : 'sub-filter-label'}>{labelText}</div>
      ) : (
        labelText
      )}
      {highlightedText && (
        <span
          style={{
            backgroundColor: '#fdefef',
            paddingBottom: '2px',
            paddingTop: '2px',
            paddingRight: '4px',
            borderRadius: '4px',
          }}
        >{`${' '} ${highlightedText}`}</span>
      )}
      <input
        type="checkbox"
        onChange={() => handleOnClick(!isChecked)}
        checked={isChecked}
        disabled={disabled}
      />
      <span
        className={
          showProductTypeIcon && customCheckboxAligment
            ? 'checkmark-product-type-vertical'
            : showProductTypeIcon && !customCheckboxAligment
            ? 'checkmark-product-type'
            : 'checkmark'
        }
      ></span>
    </label>
  );
};

export default CustomCheckbox;
